<itl-date-time
  [title]="node.title"
  [(ngModel)]="date"
  [type]="type"
  [max]="maxDate"
  [description]="node.description"
  [icon]="node.globalType ? (node.globalType | globalTypeIcon) : null"
  [required]="node.mandatory"
></itl-date-time>
